import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "h-full item-center justify-center" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body mtop-10" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-1 flex-1" }
const _hoisted_7 = { class: "flex items-center justify-end" }
const _hoisted_8 = { class: "flex items-center row justify-right" }
const _hoisted_9 = { class: "flex-2" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = { class: "txt-red font-s" }
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = { class: "txt-red font-s" }
const _hoisted_14 = { class: "row mtop-10" }
const _hoisted_15 = { class: "col-1 flex-1" }
const _hoisted_16 = { class: "flex items-center justify-end" }
const _hoisted_17 = { class: "flex items-center row justify-right" }
const _hoisted_18 = { class: "flex-2" }
const _hoisted_19 = {
  key: 0,
  class: "row"
}
const _hoisted_20 = { class: "txt-red font-s" }
const _hoisted_21 = { class: "row mtop-10" }
const _hoisted_22 = { class: "col-1 flex-1" }
const _hoisted_23 = { class: "flex-2" }
const _hoisted_24 = { class: "row mtop-10" }
const _hoisted_25 = { class: "col-1 flex-1" }
const _hoisted_26 = { class: "flex-2" }
const _hoisted_27 = {
  key: 0,
  class: "row"
}
const _hoisted_28 = { class: "txt-red font-s" }
const _hoisted_29 = { class: "row mtop-10" }
const _hoisted_30 = { class: "col-1 flex-1" }
const _hoisted_31 = { class: "flex-2" }
const _hoisted_32 = { class: "row mtop-10 mbottom-10" }
const _hoisted_33 = { class: "col-1 flex-1" }
const _hoisted_34 = { class: "flex-2" }

import { ref, watch, computed, onMounted } from "vue";
import { useI18n } from 'vue-i18n';
import { AppointmentColor, AppointmentTypeRequest, AppointmentTypeResponse, SettingsApi, GeneralPlanningSettingsResponse, AppointmentTypeApi, AppointmentColorApi } from "@/apiGenerate/medserver";
import { ApiError, ScheduleStatus } from '@/models/share.model';
import { PInputNumber } from "@/config/primevue";
import Dropdown from 'primevue/dropdown';
import { medServerApiConfig } from '@/config/medserver-api.config';
import Textarea from 'primevue/textarea';
import { useAppUserStore } from "@/stores/appUser";
import InputText from 'primevue/inputtext';
import { toastError, toastSuccess } from "@/utils/toast-utils";
import SharedService from "@/services/SharedService";
import { useToast } from "primevue";


export default /*@__PURE__*/_defineComponent({
  __name: 'esAppointmentTypeForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    appointmentType: {},
    selectedInstituteId: {},
    selectedHealthProId: {}
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = 
    __props;
const settingsApi = new SettingsApi(medServerApiConfig);
const appointmentTypeApi = new AppointmentTypeApi(medServerApiConfig);
const appointmentColorApi = new AppointmentColorApi(medServerApiConfig);
const appUserStore = useAppUserStore();

const emit = __emit;
const { t } = useI18n();
const toast = useToast();

const currentAppointmentType = ref<AppointmentTypeResponse>(props.appointmentType);
const validForm = ref<boolean>(true);

const appointmentColors = ref<AppointmentColor[]>([]);

const getAppointmentColors = async () => {
    await appointmentColorApi.listAppointmentColors().then((response: AppointmentColor[]) => {
        appointmentColors.value = response;
    }).catch((error: ApiError) => {
        toastError(toast, {
            summary: t('common.toast.error'),
            detail: t(`error.${error.status}`)
        });
    });
};

const appointmentTypeOptions = [
  { label: t('settings.label.appointmentType.online'), value: ScheduleStatus.ONLINE },
  { label: t('settings.label.appointmentType.offlineStatus'), value: ScheduleStatus.OFFLINE },
  // ES-758 : wait when feature trusted patients available
  // { label: t('settings.label.appointmentType.patient'), value: ScheduleStatus.PATIENT },
];

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const target = ref(null);
let baseAppointmentDurationInMinutes : number;

/**
 * Validates the appointment type form.
 * 
 * Checks if the `currentAppointmentType` exists and if the `note` field
 * is present and does not exceed 255 characters.
 * 
 */
const isFormValid = (): boolean => {
  validForm.value = currentAppointmentType.value.duration && currentAppointmentType.value.duration > 0 &&
         currentAppointmentType.value.name?.length > 0 && currentAppointmentType.value.name?.length <= 255 &&
         (!currentAppointmentType.value.note || currentAppointmentType.value.note.length <= 255);

  return validForm.value;
};


/**
 * Confirms the appointment type form.
 * 
 * This function validates the form using `isFormValid()`. 
 * If the form is invalid, it shows a toast error message.
 * If the form is valid, it emits the 'modal-close' event with 
 * the current appointment type data.
 * 
 */
const confirmFormModal = async () => {
  if (isFormValid()) {
    if (currentAppointmentType.value && props.selectedInstituteId) {
        const appointmentType = SharedService.cleanObject(currentAppointmentType.value);
        const appointmentTypeRequest: AppointmentTypeRequest = { ...appointmentType, color: appointmentType.color?.uuid };
        if (appointmentTypeRequest.appointmentTypeId) {
            appointmentTypeRequest.name = undefined;
           await appointmentTypeApi.updateAppointmentType({
                instituteId: props.selectedInstituteId,
                appointmentTypeId: appointmentTypeRequest.appointmentTypeId,
                appointmentTypeRequest
            }).then(() => {
                toastSuccess(toast, {
                    summary: t('common.toast.success.update'),
                    detail:  t('settings.label.appointmentType.message.success.update')
                });
                emit('modal-close', true);
            }).catch((error: ApiError) => {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });

                // Throw error to set at false the var __alreadyClicked in v-one-click directive
                throw error;
            });
        } else if (currentPersonId.value || props.selectedHealthProId) {
            await appointmentTypeApi.addAppointmentType({
                instituteId: props.selectedInstituteId,
                appointmentTypeRequest,
                doctorId: props.selectedHealthProId ? props.selectedHealthProId : currentPersonId.value
            }).then(() => {
                toastSuccess(toast, {
                    summary: t('common.toast.success.add'),
                    detail:  t('settings.label.appointmentType.message.success.add')
                });
                emit('modal-close', true);
            }).catch((error: ApiError) => {
                toastError(toast, {
                    summary: t('common.toast.error'),
                    detail: t(`error.${error.status}`)
                });

                // Throw error to set at false the var __alreadyClicked in v-one-click directive
                throw error;
            });
        }        
    } else {
      emit('modal-close');
    }
  } else {
    throw t(`error.DEFAULT`);
  }
}

const closeFormModal = () => {
    emit('modal-close');
}

const updateOffline = (newStatus: string) => {
  currentAppointmentType.value.offline = newStatus;
}

const selectAppointmentColor = (uuid: string) => {
  currentAppointmentType.value.color = appointmentColors.value.find(color => color.uuid === uuid);
}

const appointmentChipStyle = (color?: AppointmentColor) => ({
  backgroundColor: color?.backgroundColor,
  borderLeftColor: color?.trimColor,
  color: color?.textColor,
});

const getBaseAppointmentDuration = async () => {
  if (props.selectedInstituteId) {
    await settingsApi.getGeneralPlanningSettingsByInstitute({instituteId: props.selectedInstituteId,  doctorId: currentPersonId.value}).then((response: GeneralPlanningSettingsResponse) => {
     baseAppointmentDurationInMinutes = response.baseAppointmentDurationInMinutes;
    })
  }
}

watch(
    () => props.appointmentType,
  async () => {
    await getBaseAppointmentDuration();

    currentAppointmentType.value = props.appointmentType;
    if (1 < props.appointmentType.duration && props.appointmentType.duration)
    {
      currentAppointmentType.value.duration = props.appointmentType.duration/baseAppointmentDurationInMinutes;
    }
  }
);

watch(
  () => props.isOpen,
  () => {
    validForm.value = true;
  }
)

onMounted(() => {
  getAppointmentColors();
});


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "form-modal-container",
            ref_key: "target",
            ref: target
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_es_modal_header, {
                header: _unref(t)(_ctx.header)
              }, null, 8, ["header"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('settings.label.appointmentType.name'),
                        styles: "main-m"
                      }, null, 8, ["txt"]),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "main-alert ml-1" }, "*", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(InputText), {
                    type: "text",
                    class: "input-text w-full",
                    invalid: currentAppointmentType.value.name?.length >= 255,
                    modelValue: currentAppointmentType.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentAppointmentType.value.name) = $event)),
                    required: ""
                  }, null, 8, ["invalid", "modelValue"]),
                  (!validForm.value && currentAppointmentType.value.name?.length >= 255)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(t)('settings.error.numberMaxChar')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!validForm.value && (!currentAppointmentType.value.name || currentAppointmentType.value.name?.length == 0))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)('error.REQUIRED')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('settings.label.appointmentType.duration'),
                        styles: "main-m",
                        class: "align-r"
                      }, null, 8, ["txt"]),
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "main-alert ml-1" }, "*", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(PInputNumber), {
                    modelValue: currentAppointmentType.value.duration,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentAppointmentType.value.duration) = $event)),
                    class: "input-field w-full",
                    min: 1,
                    size: "small",
                    showButtons: "",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  (!validForm.value && (!currentAppointmentType.value.duration || currentAppointmentType.value.duration < 1))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)('error.REQUIRED')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('settings.label.appointmentType.fieldColor'),
                    styles: "main-m",
                    class: "align-r"
                  }, null, 8, ["txt"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_unref(Dropdown), {
                    modelValue: currentAppointmentType.value.color?.uuid,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = (uuid) => selectAppointmentColor(uuid)),
                    options: appointmentColors.value,
                    optionValue: "uuid",
                    class: "custom-input input-text-status w-full"
                  }, {
                    value: _withCtx((slotProps) => [
                      (slotProps.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "appointment-chip",
                            style: _normalizeStyle(appointmentChipStyle(appointmentColors.value.find(color => color.uuid === slotProps.value)))
                          }, _toDisplayString(currentAppointmentType.value.name.length === 0 ? _unref(t)('settings.label.appointmentType.fieldColor') : currentAppointmentType.value.name), 5))
                        : _createCommentVNode("", true)
                    ]),
                    option: _withCtx((slotProps) => [
                      _createElementVNode("span", {
                        class: "appointment-chip",
                        style: _normalizeStyle(appointmentChipStyle(slotProps.option))
                      }, _toDisplayString(currentAppointmentType.value.name.length === 0 ? _unref(t)('settings.label.appointmentType.fieldColor') : currentAppointmentType.value.name), 5)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('settings.label.appointmentType.note'),
                    styles: "main-m",
                    class: "align-r"
                  }, null, 8, ["txt"])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(Textarea), {
                    modelValue: currentAppointmentType.value.note,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentAppointmentType.value.note) = $event)),
                    invalid: currentAppointmentType.value.note?.length >= 255,
                    size: "small",
                    autoResize: "",
                    class: "w-full"
                  }, null, 8, ["modelValue", "invalid"]),
                  (!validForm.value && currentAppointmentType.value.note?.length >= 255)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(t)('settings.error.numberMaxChar')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('settings.label.appointmentType.order'),
                    styles: "main-m",
                    class: "align-r"
                  }, null, 8, ["txt"])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_unref(PInputNumber), {
                    modelValue: currentAppointmentType.value.order,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentAppointmentType.value.order) = $event)),
                    class: "input-field w-full",
                    size: "small",
                    disabled: true
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('settings.label.appointmentType.offline'),
                    styles: "main-m",
                    class: "align-r"
                  }, null, 8, ["txt"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_unref(Dropdown), {
                    modelValue: currentAppointmentType.value.offline,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentAppointmentType.value.offline) = $event)),
                    options: appointmentTypeOptions,
                    optionLabel: "label",
                    optionValue: "value",
                    class: "custom-input input-text-status w-full",
                    onChange: _cache[6] || (_cache[6] = (e) => updateOffline(e.value))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createVNode(_component_es_modal_footer, {
                  onModalCancel: closeFormModal,
                  confirmModalMethod: async () => await confirmFormModal()
                }, null, 8, ["confirmModalMethod"])
              ])
            ])
          ], 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})